import { useTranslation } from 'react-i18next';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

import Layout from '@/components/template/Layout';
import Feedback from '@/components/ui/custom/CannyFeedback';
import PageTitle from '@/components/ui/custom/PageTitle';
import MainButton from '@/components/ui/custom/buttons/MainButton';

export default function SuggestionsPage() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'suggestionsPage',
  });

  return (
    <Layout>
      <PageTitle
        headingText={t('suggestions')}
        subheadingText={t('subheading')}
      />
      <MainButton
        icon={<ArrowPathIcon />}
        data-canny-changelog
        text={t('updates')}
        className="mb-2"
      />

      <Feedback path="/sugestoes" />
    </Layout>
  );
}
